import SummaryColumn from 'modules/Station/components/SummaryColumn/SummaryColumn'
import { ReactComponent as StackManagerIcon } from 'icons/string-manager.svg'
import BinaryBarChartTotalVsUsed from 'components/Charts/BinaryBarChart/BinaryBarChartTotalVsUsed'

const StackManagersListSummary = ({ data }) => {
  if (!data) return null

  const summaryMap = {
    title: 'Stack Managers',
    titleIcon: <StackManagerIcon />,
    titleChart: (
      <BinaryBarChartTotalVsUsed
        positiveCount={data.healthyTotal}
        totalCount={data.total}
        tooltip={`Healthy: ${data.healthyTotal} | Total: ${data.total}`}
        id="stackManagersHealth"
      />
    ),
    sections: [
      {
        sectionTitle: 'STATUS',
        rows: [
          {
            label: 'Healthy',
            value: data.healthyTotal.toLocaleString(),
          },
          {
            label: 'Total',
            value: data.total.toLocaleString(),
          },
        ],
      },
    ],
  }

  return <SummaryColumn summaryMap={summaryMap} />
}

export default StackManagersListSummary
